import React from 'react';
import { Rocket, clock, Zap } from 'lucide-react';

const PortfolioSection = () => {
  return (
    <section id="portfolio" className="py-24 bg-brand-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
          Our <span className="text-brand-magenta">Portfolio</span>
        </h2>
        
        <div className="bg-brand-darker border-2 border-dashed border-brand-magenta/30 rounded-3xl p-12 md:p-20 relative overflow-hidden">
          {/* Arka plan ışığı */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-brand-magenta/10 blur-[100px]" />

          <div className="relative z-10 flex flex-col items-center">
            <div className="w-20 h-20 bg-brand-magenta/20 rounded-full flex items-center justify-center mb-6 animate-pulse">
              <Rocket className="text-brand-magenta" size={40} />
            </div>
            
            <h3 className="text-3xl font-bold text-white mb-4">New Projects Loading...</h3>
            
            <p className="text-gray-400 text-lg max-w-2xl mx-auto mb-8">
              ViralVantage Media is currently updating its portfolio with our latest viral campaigns. 
              Our new high-retention masterpieces will be showcased here very soon.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-4xl">
              <div className="p-6 bg-white/5 rounded-2xl border border-white/10">
                <Zap className="text-brand-glow mb-3 mx-auto" />
                <h4 className="text-white font-bold italic text-sm">RE-EDITING FOR MAX RETENTION</h4>
              </div>
              <div className="p-6 bg-white/5 rounded-2xl border border-white/10">
                <Rocket className="text-brand-magenta mb-3 mx-auto" />
                <h4 className="text-white font-bold italic text-sm">UPLOADING 4K CASE STUDIES</h4>
              </div>
              <div className="p-6 bg-white/5 rounded-2xl border border-white/10">
                <Zap className="text-brand-glow mb-3 mx-auto" />
                <h4 className="text-white font-bold italic text-sm">STRATEGIZING VIRAL HOOKS</h4>
              </div>
            </div>

            <button 
              onClick={() => document.getElementById('free-audit').scrollIntoView({ behavior: 'smooth' })}
              className="mt-10 text-brand-magenta font-bold hover:underline flex items-center gap-2"
            >
              Want to see our work samples privately? Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;